import OrderingStoreService from "@/services/OrderingStoreService";

const rejectApiError = (error) => Promise.reject(error.response?.data || error);

export const orderingStore = {
  namespaced: true,
  actions: {
    getConfiguration() {
      return OrderingStoreService.GetConfiguration().catch(rejectApiError);
    },
    saveConfiguration(context, payload) {
      return OrderingStoreService.SaveConfiguration(payload).catch(
        rejectApiError
      );
    },
    uploadAsset(context, { type, file }) {
      return OrderingStoreService.UploadAsset(type, file).catch(rejectApiError);
    },
  },
};
